/**
 * @fileoverview Route Error Boundary — react-router v7 errorElement.
 * 404 ve 500 hatalarını ayırt eder; header/footer görünür kalır.
 */

import { useRouteError, useNavigate, isRouteErrorResponse } from 'react-router-dom'
import { HiOutlineArrowLeft } from 'react-icons/hi2'

export default function RouteErrorBoundary() {
  const error     = useRouteError()
  const navigate  = useNavigate()

  const is404 = isRouteErrorResponse(error) && error.status === 404
  const code  = isRouteErrorResponse(error) ? error.status : 500

  return (
    <div
      role="alert"
      className="min-h-screen flex items-center justify-center bg-[#0D172A] px-6"
    >
      <div className="max-w-lg w-full text-center">
        {/* Gold divider */}
        <div
          className="w-12 h-[2px] mx-auto mb-10"
          style={{ background: 'linear-gradient(90deg,#BF953F,#FCF6BA,#AA771C)' }}
        />

        {/* Error code */}
        <p
          className="text-7xl font-black mb-4"
          style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            background: 'linear-gradient(90deg, #BF953F, #FCF6BA, #AA771C)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {code}
        </p>

        <p className="text-xs uppercase tracking-[0.3em] text-[#BF953F] mb-4 font-semibold">
          {is404 ? 'Sayfa Bulunamadı' : 'Sunucu Hatası'}
        </p>

        <p className="text-white/60 mb-10 leading-relaxed">
          {is404
            ? 'Aradığınız sayfa mevcut değil veya taşınmış olabilir.'
            : 'Sunucu taraflı bir hata oluştu. Lütfen sayfayı yenileyin.'}
        </p>

        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-[#0D172A] rounded-sm transition-transform hover:scale-105"
          style={{ background: 'linear-gradient(135deg,#BF953F 0%,#FCF6BA 40%,#B38728 60%,#AA771C 100%)' }}
        >
          <HiOutlineArrowLeft className="w-4 h-4" aria-hidden="true" />
          Ana Sayfaya Dön
        </button>

        <div
          className="w-12 h-[2px] mx-auto mt-10"
          style={{ background: 'linear-gradient(90deg,#BF953F,#FCF6BA,#AA771C)' }}
        />
      </div>
    </div>
  )
}
